import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0de68f64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white list-compone-wrap newslist-conn" }
const _hoisted_2 = { class: "bg-white px-[60px] pb-[60px] news-article-wrap" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = { class: "title text-[18px] text-[#333] leading-[20px] mb-[20px]" }
const _hoisted_7 = { class: "text-[14px] leading-[14px] text-[#999] inline-block border-b-[2px] border-[#666] pb-[5px]" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "flex justify-center" }

import MutilListSwiper, {
  IListItem,
} from "@/components/SwiperComp/MutilListSwiper.vue";
import {
  withDefaults,
  reactive,
  onMounted,
  ref,
  toRaw,
  nextTick,
} from "vue";
import { IPagination } from "@/interface/index";
import { getPage } from "@/http/api/index";
import useGetNewsNavList from "@/hooks/useGetNewsNavList";
import { IItem } from "@/interface/newsInterface";
interface IProps {
  type: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ListComp',
  props: {
    type: { default: "" }
  },
  emits: ["handleClick"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const pagination = reactive<IPagination>({
  total: 0,
  pageSize: 4,
  pageNum: 1,
});

const searchParams = reactive({
  menuId: "",
});
const data = reactive<{
  swiperList: Array<IItem>;
  NavList: Array<IListItem>;
  articleList: Array<IItem>;
}>({
  swiperList: [],
  NavList: [],
  articleList: [],
});
const props = __props;
const menuPath = props.type == "news" ? "/news" : "/policies";
const { getNewsInfo } = useGetNewsNavList(menuPath, pullData);
function handleEmit(item) {
  emit("handleClick", item);
}
function currentChange(pageNum) {
  console.log(pageNum)
  pagination.pageNum = pageNum;
  getSelPage();
}
function pullData(res) {
  console.log(res);
  data.NavList = res.data.leftList || [];
  console.log(data.NavList);
  if (!data.NavList.length) return;
  pagination.pageNum = 1;
  searchParams.menuId = data.NavList[0].id;
  getSelPage();
}

function getSelPage() {
  getPage<Array<IItem>>({
    ...toRaw(searchParams),
    pageNum: pagination.pageNum,
    pageSize: pagination.pageSize,
  }).then((res) => {
    pagination.total = res.total as number;
    if (pagination.pageNum == 1) {
      data.swiperList = [];
      nextTick(() => {
        data.swiperList = res.rows?.slice(0, 3);
      });
      
    } 
    data.articleList = res.rows;
  });
}

function hanldeChange(index) {
  pagination.pageNum = 1;
  searchParams.menuId = data.NavList[index]?.id;
  getSelPage();
}

onMounted(() => {
  getNewsInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MutilListSwiper, {
      NavList: data.NavList,
      swiperList: data.swiperList,
      onToDetail: handleEmit,
      "is-empty": !pagination.total,
      onHanldeChange: hanldeChange
    }, null, 8, ["NavList", "swiperList", "is-empty"]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.articleList, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "list-li flex mb-[48px] cursor-pointer",
          onClick: ($event: any) => (handleEmit(item))
        }, [
          _createElementVNode("img", {
            src: item.banner,
            class: "w-[380px] h-[168px] mr-[24px] object-cover flex-shrink-0"
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(item.title), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(item.createTime), 1),
            _createElementVNode("p", {
              class: "w-[100%] h-[66px] text-[14px] text-[#666] mt-[20px] leading-[22px] desc indent-[2em]",
              innerHTML: item.digest
            }, null, 8, _hoisted_8)
          ])
        ], 8, _hoisted_3))
      }), 128)),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_pagination, {
          "prev-text": "上一页",
          "next-text": "下一页",
          background: "",
          layout: "prev, pager, next",
          "current-page": pagination.pageNum,
          total: pagination.total,
          "page-size": pagination.pageSize,
          onCurrentChange: currentChange
        }, null, 8, ["current-page", "total", "page-size"])
      ])
    ], 512), [
      [_vShow, pagination.total]
    ]),
    _withDirectives(_createVNode(_component_el_empty, { description: "暂无数据" }, null, 512), [
      [_vShow, !pagination.total]
    ])
  ]))
}
}

})